import { Box, Button, ButtonProps, CircularProgress } from '@mui/material';
import { FunctionComponent } from 'react';

type Props = {
    isLoading: boolean;
} & ButtonProps;

export const ProgressButton: FunctionComponent<Props> = ({ children, isLoading, disabled, ...props }) => {
    return (
        <Box component="div" sx={{ position: 'relative' }}>
            <Button {...props} disabled={isLoading || disabled}>
                {children}
            </Button>
            {isLoading && (
                <CircularProgress
                    size={24}
                    sx={{ position: 'absolute', top: '50%', left: '50%', marginTop: '-12px', marginLeft: '-12px' }}
                />
            )}
        </Box>
    );
};
